const router = [
  //中再生产业园进场
  {
    path: '/in/register',
    name: 'InRegister',
    component: () => import('@/views/registration/InRegister.vue'),
    meta: {
      title: '进厂登记',
      checkToken: false
    }
  },
  //立铭进场
  {
    path: '/in/register/lm',
    name: 'InRegisterLm',
    component: () => import('@/views/registration/InRegisterLm.vue'),
    meta: {
      title: '进厂登记',
      checkToken: false
    }
  },
  {
    path: '/in/register/reason',
    name: 'InRegisterReason',
    component: () => import('@/views/registration/InRegisterReason.vue'),
    meta: {
      title: '进厂登记',
      checkToken: false
    }
  },
  {
    path: '/in/register/form',
    name: 'InRegisterForm',
    component: () => import('@/views/registration/InRegisterForm.vue'),
    meta: {
      title: '进厂登记',
      checkToken: false
    }
  },
  {
    path: '/leave/confrim',
    name: 'LeaveConfrim',
    component: () => import('@/views/registration/LeaveConfrim.vue'),
    meta: {
      title: '离场确认',
      checkToken: false
    }
  },
  {
    path: '/inbound',
    name: 'Inbound',
    component: () => import('@/views/registration/Inbound.vue'),
    meta: {
      title: '入库车辆登记表',
      checkToken: false
    }
  },
  {
    path: '/outbound',
    name: 'Outbound',
    component: () => import('@/views/registration/Outbound.vue'),
    meta: {
      title: '出库车辆登记表',
      checkToken: false
    }
  }
];
export default router;
